import {
	blackColor,
	grayColor,
	grayColorShade_1,
	grayColorShade_2,
	grayColorShade_3,
	lightGreenShade_2,
	orangeShade1,
	whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const bwodPlanDetailsStyle = (theme) => ({
	planDetails: {
		border: `1px solid ${grayColor[14]}`,
		padding: '10px',
		marginTop: '20px',
		borderRadius: '4px',
	},
	accordionPlanDetails: {
		border: `1px solid ${whiteColor}`,
		padding: '10px',
		marginTop: '20px',
		borderRadius: '4px',
	},
	expiredBox: {
		border: `1px solid ${grayColor[9]}`,
		padding: '10px',
		marginTop: '20px',
		borderRadius: '4px',
	},
	planInfoContent: {
		display: 'flex',
		justifyContent: 'space-between',
		[theme.breakpoints.down('md')]: {
			'min-width': 'auto',
		},
	},
	planInfo: {
		marginRight: '8px',
	},
	planInfolabel: {
		color: `${grayColorShade_1}`,
	},
	planName: {
		display: 'inline-flex',
	},
	infoIcon: {
		marginLeft: '10px',
		color: blackColor,
	},
	statusButton: {
		backgroundColor: (props) => `${props.buttonColor} !important`,
		color: `${whiteColor} !important`,
		textTransform: 'capitalize',
		width:'21%',
		marginLeft: '5px',
		padding:'10px',
		'&.Mui-disabled': {
			color: `${whiteColor} !important`,
		},
	},
	planWrapper: {
		display: 'flex',
		justifyContent: 'space-between'

		// [theme.breakpoints.up('sm')]: {
		// 	display: 'flex !important',
		// 	justifyContent: 'space-between !important',
		// },
	},
	singlePlanWrapper: {
		marginLeft: '10px',
		display: 'flex !important',
		justifyContent: 'space-between !important',
		margin: '0 17px 0 12px',
	},
	whiteText: {
		color: `${whiteColor} !important`,
	},
	tooltipKey: {
		color: `${whiteColor} !important`,
		marginRight: '5px',
	},
	toolTip: {
		background: blackColor,
	},
	tooltipInfo: {
		color: `${whiteColor} !important`,
		padding: '0 0 0 10px',
	},
	tooltipListItem: {
		display: 'inline-flex',
	},
	active: {
		backgroundColor: `${lightGreenShade_2} !important`,
		color: `${whiteColor} !important`,
		textTransform: 'capitalize',
		'&.Mui-disabled': {
			color: `${whiteColor} !important`,
		},
	},
	pending: {
		backgroundColor: `${orangeShade1} !important`,
		color: `${whiteColor} !important`,
		padding:'10px !important',
		textTransform: 'capitalize',
		'&.Mui-disabled': {
			color: `${blackColor} !important`,
		},
		marginLeft: '5px',
	},
	expired: {
		backgroundColor: `${grayColorShade_3} !important`,
		color: `${whiteColor} !important`,
		textTransform: 'capitalize',
		'&.Mui-disabled': {
			color: `${whiteColor} !important`,
		},
	},
	caption: {
		color: `${grayColorShade_2} !important`,
		marginBotton: '8px',
	},
});

export default bwodPlanDetailsStyle;
